import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

$(() => {
  const getSrcYouTubeUrl = (src) => {
    src = src.replace(
      /(\/\/)www\.youtube\.com\//,
      '$1www.youtube-nocookie.com/'
    );
    const controlParam = 'enablejsapi=1';
    const hasQueryParams = src.includes('?');
    if (!src.includes(controlParam)) {
      src += hasQueryParams ? `&${controlParam}` : `?${controlParam}`;
    }
    return src;
  };

  const createIframe = (url) => {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.setAttribute('frameborder', '0');
    return iframe;
  };

  const createContainer = (iframe) => {
    const container = document.createElement('div');
    container.className = 'pswp__iframe-container';
    container.appendChild(iframe);
    return container;
  };

  const lightboxPhotosOptions = {
    gallery: '#property-photos-carousel',
    children: '.slick-slide:not(.slick-cloned) a',
    imageClickAction: 'next',
    tapAction: 'next',
    clickToCloseNonZoomable: false,
    bgOpacity: 0.95,
    wheelToZoom: true,
    initialZoomLevel: "fit",
    secondaryZoomLevel: 2.0,
    maxZoomLevel: 4,
    doubleTapAction:'zoom',
    pswpModule: () => import('photoswipe'),
  };
  const lightboxPhotos = new PhotoSwipeLightbox(lightboxPhotosOptions);

  lightboxPhotos.on('contentLoad', (event) => {
    const item = event.content;
    if (item === undefined || item.index === NaN) {
      return;
    }
    // If the image has a placeholder size of 1200x800, we need to fetch the real size
    if (item.data.w === 1200 && item.data.h === 800) {
      const img = new Image();
      img.onload = function () {
        item.data.w = this.naturalWidth;
        item.data.h = this.naturalHeight;
        item.data.height = this.naturalHeight;
        item.data.width = this.naturalWidth;
        item.data.element.setAttribute('data-pswp-width', this.naturalWidth);
        item.data.element.setAttribute('data-pswp-height', this.naturalHeight);
        lightboxPhotos.pswp.refreshSlideContent(item.index);
        img.onload = null;
      };
      img.src = item.data.src;
    }
  });

  const lightboxVideo = new PhotoSwipeLightbox({
    gallery: '#open-property-video-modal',
    children: 'a',
    bgOpacity: 0.95,
    pswpModule: () => import('photoswipe'),
  });

  lightboxVideo.on('contentLoad', (event) => {
    const item = event.content;
    if (!item || !item.data) return;
    const iframe = createIframe(getSrcYouTubeUrl(item.data.src));
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen;'
    );
    iframe.setAttribute('allowfullscreen', 'true');
    item.data.html = createContainer(iframe).outerHTML;
  });

  const lightboxVirtualTour = new PhotoSwipeLightbox({
    gallery: '#open-virtual-tour-modal',
    children: 'a',
    bgOpacity: 0.95,
    pswpModule: () => import('photoswipe'),
  });

  lightboxVirtualTour.on('contentLoad', (event) => {
    const item = event.content;
    if (!item || !item.data) return;
    // Create the iframe element
    const iframe = createIframe(item.data.src);
    item.data.html = createContainer(iframe).outerHTML;
  });

  lightboxPhotos.init();
  lightboxVirtualTour.init();
  lightboxVideo.init();

  $('#open-virtual-tour-modal').on('click', (event) => {
    event.preventDefault();
    lightboxVirtualTour.loadAndOpen(0);
  });

  $('#open-property-video-modal').on('click', (event) => {
    event.preventDefault();
    lightboxVideo.loadAndOpen(0);
  });

  $('#open-property-photos-carousel').on('click', (event) => {
    event.preventDefault();
    const slickIndex =
      parseInt(
        $('#property-photos-carousel')
          .find('.slick-active')
          .attr('data-slick-index')
      ) || 0;
    lightboxPhotos.loadAndOpen(slickIndex);
  });
  window.lightboxPhotos = lightboxPhotos;
});
